import { useCallback, useEffect, useState } from "react";
import axiosInstance from "../../apiInstances/axiosInstance";
import { normalizePropertyList } from "../../utils/normalizePropertyList";

function extractPropertyList(responseData) {
  const payload = responseData?.data;
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.properties)) return payload.properties;
  if (Array.isArray(responseData?.properties)) return responseData.properties;
  return [];
}

export function useRecentlySoldProperties(limit = 10) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await axiosInstance.get("/recentlySoldProperties", {
        params: { limit },
      });
      const list = extractPropertyList(res?.data);
      setData(normalizePropertyList(list));
    } catch (e) {
      setError(e);
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [limit]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}
